import * as React from 'react';

import { DEFAULT_LABOR_PLACEHOLDER } from 'ab-common/constants/value';

import CustomScrollbar from 'af-components/CustomScrollbar';

import AvailableEmployees from './AvailableEmployees';
import UnavailableEmployees from './UnavailableEmployees';
import ResourcePlaceholder from '../../ResourcePlaceholder';

interface OwnProps {
	dueDate: string;
	isDragAndDropDisabled: boolean;
	hasPermissionsToEditScheduleBoard: boolean;
	hasPermissionsToSendNotifications: boolean;
	sendNotification: (dueDate: string, notifyByEmail: number[], notifyBySms: number[]) => void;
	scheduleAutoNotify: (dueDate: string, notifyByEmail: number[], notifyBySms: number[]) => void;
}

type Props = OwnProps;

export default (props: Props) => {
	const {
		dueDate,
		sendNotification,
		isDragAndDropDisabled,
		hasPermissionsToEditScheduleBoard,
		hasPermissionsToSendNotifications,
		scheduleAutoNotify,
	} = props;

	return (
		<CustomScrollbar
			contentWrapperClassName="schedule-board-toolbar-column employees"
			isHorizontalHidden={true}
			isVerticalHidden={true}
			scrollbarsClassName="schedule-board-toolbar-column-wrapper employees"
		>
			<ResourcePlaceholder
				dueDate={dueDate}
				isPlaceholder={false}
				label="Labor"
				uniqueCode={DEFAULT_LABOR_PLACEHOLDER}
			/>
			<AvailableEmployees
				dueDate={dueDate}
				hasPermissionsToEditScheduleBoard={hasPermissionsToEditScheduleBoard}
				hasPermissionsToSendNotifications={hasPermissionsToSendNotifications}
				isDragAndDropDisabled={isDragAndDropDisabled}
				scheduleAutoNotify={scheduleAutoNotify}
				sendNotification={sendNotification}
			/>
			<UnavailableEmployees
				dueDate={dueDate}
				hasPermissionsToEditScheduleBoard={hasPermissionsToEditScheduleBoard}
				isDragAndDropDisabled={isDragAndDropDisabled}
			/>
		</CustomScrollbar>
	);
};
